var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sw-avatar',
    {
      'sw-avatar--clickable': _vm.clickable,
      'sw-avatar--selected': _vm.selected,
      'sw-avatar--image': _vm.useImage,
    }
  ],style:(_vm.rootStyle)},[_c('div',{class:['sw-avatar__inner', 'sw-flexbox', 'sw-flexbox--inline',
      'sw-flexbox--center-items', 'sw-flexbox--center-justify' ]},[(!_vm.useImage)?_c('span',{class:['sw-avatar__initials']},[_vm._v(_vm._s(_vm.initials))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }